import axios from 'axios';

const api = axios.create({
  baseURL: 'http://localhost:8001'
});

// Attach token to requests if present
api.interceptors.request.use(config => {
  const token = localStorage.getItem('idToken');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

export const fetchImageCounts = async () => {
  try {
    const res = await api.get('/api/photos/images/counts');
    return res.data;
  } catch (error) {
    console.error('Failed to fetch image counts:', error);
    return { unlabeled_count: 0, alert_count: 0, labeled_count: 0 };
  }
};

export const fetchUploadCounts = async () => {
  try {
    const res = await api.get('/api/photos/uploads/counts');
    return res.data;
  } catch (error) {
    console.error('Failed to fetch upload counts:', error);
    return { last_30_days: 0, last_60_days: 0, last_90_days: 0 };
  }
};

export const fetchStats = async () => {
  try {
    const res = await api.get('/api/photos/stats');
    return res.data; // { manufacturers:{…}, shingle_types:{…}, colors:{…} }
  } catch {
    return { manufacturers:{}, shingle_types:{}, colors:{} };
  }
};

// 1) Get manufacturer totals
export const fetchManufacturers = async () => {
  try {
    const res = await api.get('/api/photos/stats');
    return res.data.manufacturers || {};
  } catch {
    return {};
  }
};

// 2) Get shingle-type totals for a manufacturer
export const fetchShingleTypes = async (manufacturer) => {
  try {
    const res = await api.get('/api/photos/stats', {
      params: { manufacturer }
    });
    return res.data.shingle_types || {};
  } catch {
    return {};
  }
};

// 3) Get color totals for a manufacturer + shingle_type
export const fetchColors = async (manufacturer, shingle_type) => {
  try {
    const res = await api.get('/api/photos/stats', {
      params: { manufacturer, shingle_type }
    });
    return res.data.colors || {};
  } catch {
    return {};
  }
};